import axios from 'axios'
import {getToken, removeToken} from "../utils/auth";
import {Message} from "element-ui";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;


axios.interceptors.request.use(
    config=>{
        if(getToken()){
            config.headers.Authorization = getToken();
        }
        return config;
    },
    error => {
        return Promise.reject(error)
    }
)


axios.interceptors.response.use(
    response =>{
        if(response.data.code == 0){
            return response.data.data;
        }else if(response.data.code == 401){
            removeToken()
        }
        else{
            return Promise.reject(response)
        }
    },
    error => {
        Message.error("网络错误")
        return Promise.reject(error)
    }
)

export default axios;